import { ProspectResponse } from "src/redux/prospects/prospects.types";
import { awsAPIConfigFactory } from "./configs/awsConfig";
const queryParams = new URLSearchParams({ country: 'MX' });

const urlProspects = `${process.env.REACT_APP_ADMINISTRATION_API_URL}prospect`;

const prospectAPIConfigs = awsAPIConfigFactory(process.env.REACT_APP_ADMINISTRATION_XAPIKEY)
export const getProspects = async ({ token, values }): Promise<ProspectResponse> => {
    const urlRequest = `${urlProspects}?country=MX&${values}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('GET', token));
    const response = await res.json();
    response.prospects = response.prospects.map(prospect => {
        prospect.created = prospect.created ? new Date(prospect.created) : null;
        prospect.note_updated_at = prospect.note_updated_at ? new Date(prospect.note_updated_at) : null;
        return prospect;
    })
    return (response as ProspectResponse);
};

export const getProspectsCatalogs = async ({ token }) => {
    const urlRequest = `${urlProspects}/catalogs?country=MX`;
    const res = await fetch(urlRequest, prospectAPIConfigs('GET', token));
    return res.json();
}

export const updateTypification = async ({ token, prospect_id, typification_id }) => {
    const body = {
        typification_id
    }
    const urlRequest = `${urlProspects}/${prospect_id}/typification?${queryParams}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('PUT', token, body));
    return res.json();
}

export const updateAttention = async ({ token, prospect_id, attention_id }) => {
    const body = {
        attention_id
    }

    const urlRequest = `${urlProspects}/${prospect_id}/attention?${queryParams}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('PUT', token, body));
    return res.json();
}

export const updateRecommendation = async ({ token, prospect_id, recommendation_id }) => {
    const body = {
        recommendation_id
    }
    const urlRequest = `${urlProspects}/${prospect_id}/recommendation?${queryParams}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('PUT', token, body));
    return res.json();
}

export const updateCSAssignation = async ({ token, prospect_id, assigned_id }) => {
    const body = {
        assigned_id
    }
    const urlRequest = `${urlProspects}/${prospect_id}/assigned?${queryParams}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('PUT', token, body));
    return res.json();
}

export const updateNoteProspect = async ({ token, prospect_id, note }) => {
    const body = {
        note_content: note
    }
    const urlRequest = `${urlProspects}/${prospect_id}/note?${queryParams}`;
    const res = await fetch(urlRequest, prospectAPIConfigs('PUT', token, body));
    return res.json();
}